export default "__VITE_ASSET__VH1rugSR__"